import { noop } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ArchivedFile } from 'src/models/archived-file';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FileTable, FormPanel, useFetch } from '@eas/common-web';
import { TechnicalObject } from '@models';
import { EvidenceApiUrl } from '@enums';

type Props = {
  workOrderId: string;
  workOrderName: string;
  technicalObjectId?: string;
};

export default function TechnicalObjectAttachmentField({
  workOrderId,
  workOrderName,
  technicalObjectId,
}: Props) {
  const [technicalObject, loading] = useFetch<TechnicalObject>(
    `${EvidenceApiUrl.TECHNICAL_OBJECTS}/${technicalObjectId}/work-order/${workOrderId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  return (
    <FormPanel
      label={
        <FormattedMessage
          id="ZSD__TECHNICAL_OBJECT__DETAIL__FIELD_LABEL__ATTACHMENTS"
          defaultMessage={`Prílohy (iba pracovný príkaz ${workOrderName})`}
        />
      }
    >
      {loading ? (
        <CircularProgress />
      ) : (
        <FileTable
          value={technicalObject?.attachments?.map((a: ArchivedFile) => a.file)}
          disabled={true}
          onChange={noop}
        />
      )}
    </FormPanel>
  );
}
